import { filter } from "rxjs/operators";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { AwsService } from "./../../../providers/appsyncservice/aws.service";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-driver-master",
  templateUrl: "./driver-master.component.html",
  styleUrls: ["./driver-master.component.css"]
})
export class DriverMasterComponent implements OnInit {
  displayDriverValue: Number = 0;
  errorMsg: string = "Loading... Please wait...";
  public searchErr: string = "";
  public driverList: any = [];
  isValid: any = true;
  public formGroup: FormGroup;
  public showEdit: boolean;
  public showSearch: boolean;
  public showBack: boolean;

  sortKey: string = 'sno'; //set default
  sortReverse: boolean = false;

  noOfItems=10;
  
  constructor(public awserviceProvider: AwsService) {
    this.getDriverData();
  }

  ngOnInit() {
    this.initiateFormGroup();
  }

  initiateFormGroup() {
    this.formGroup = new FormGroup({
      username: new FormControl(),
      id: new FormControl(),
      user_pid: new FormControl(),
      driver_name: new FormControl(),
      date_of_birth: new FormControl(),
      driving_license_no: new FormControl(),
      license_exp_date: new FormControl(),
      vendor_name: new FormControl(),
      is_active: new FormControl(),
      is_assigned: new FormControl(),
      ex_data: new FormControl(),
      created_date: new FormControl(),
      updated_date: new FormControl()
    });
  }

  editDriver(driver) {
    this.displayDriverValue = 1;
    this.showEdit = true;
    this.showSearch = false;

    var dt = new Date();
    this.formGroup.patchValue({
      id: driver.id,
      user_pid: driver.user_pid,
      driver_name: driver.driver_name,
      date_of_birth: driver.date_of_birth,
      driving_license_no: driver.driving_license_no,
      license_exp_date: driver.license_exp_date,
      vendor_name: driver.vendor_name,
      is_active: driver.is_active,
      is_assigned: driver.is_assigned,
      ex_data: driver.ex_data,
      created_date: driver.created_date,
      updated_date: dt.toISOString()
    });
  }

  getDriverData() {
    this.awserviceProvider
      .getDriverList()
      .then(res => {
        this.constructData(res);
        console.log("getDriverData", res);
        if (res.length == 0)
          this.errorMsg =
            "Sorry!. There no driver is found. Press Add button and add driver and check here";
      })
      .catch(err => {
        this.errorMsg = "Sorry!. Something went wrong! Try again!";
      });
  }

  constructData(data){
    this.driverList=[]
    var oplist=[]
    for(var i in data){
      data[i].sno=+i+1;
      oplist.push(data[i])
    }
    this.driverList=oplist;
  }

  findDriver() {
    this.showEdit = false;
    console.log("findDriver", this.formGroup.value);
    this.searchErr = "Loading...Please wait...";
    this.awserviceProvider
      .findUserByUserName(this.formGroup.value.username)
      .then(res => {
        console.log("findDriver", res);
        this.searchErr = "";
        if (res.length > 0) {
          var data = res[0];
          console.log("findDriver", data.user_type);
          if (data.user_type === 3) {
            var exists = this.driverList.filter(rs => {
              return rs.user_pid === data.id;
            });

            if (exists.length > 0) {
              this.searchErr =
                "You have already added this driver. Try Different";
            } else {
              this.showEdit = true;
              this.showBack=false;
              /*  this.formGroup.setValue({
                user_pid:data.id,
                driver_name:data.name
              }) */
              this.formGroup.reset("");
              var dt = new Date();
              this.formGroup.patchValue({
                user_pid: data.id,
                driver_name: data.name,
                created_date: dt.toISOString(),
                updated_date: dt.toISOString()
              });
            }
          } else {
            this.searchErr = "This Username is not a Perosnal Driver";
          }
        } else {
          this.searchErr = "Username is not found! Try Different";
        }
      });
  }

  driverDataSubmit() {
    console.log("driverDataSubmit", this.formGroup.value);
    if (this.formGroup.value.id === null) {
      this.awserviceProvider
        .CreateDriverData(this.formGroup.value)
        .then(res => {
          this.getDriverData();
          this.displayDriverValue = 0;
        });
    } else {
      console.log("driverDataSubmitUpdate", this.formGroup.value);
      this.awserviceProvider
        .UpdateDriverData(this.formGroup.value)
        .then(res => {
          this.getDriverData();
          this.displayDriverValue = 0;
        });
    }
  }

  driverDelete(id) {
    console.log("driverDelete", id);
    var c = window.confirm("Are you sure want to delete this?");
    if (c) {
      this.awserviceProvider.deleteDriverData(id).then(res => {
        console.log("driverDelete", res);
        this.getDriverData();
      });
    }
  }


  public sort(sortKey){
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey){
    if(this.sortKey==sortKey){
      if(this.sortReverse){
        return 'fa fa-sort-desc';
      }
      else
      {
        return 'fa fa-sort-asc';
      }
    }
    else{
      return 'fa fa-sort';
    }
    
  }

}
